import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import DiseaseService from '../../services/diseaseService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { DiseaseGridModel, DiseaseForGridModel, DiseaseFilterSettingsModel } from "../../models/disease";
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import AlertMessage from '../../common/components/alertMessage/alertMessage';

interface IProps {
  isVisible: boolean,
  cancelClick: any,
  addClick: any,
  validationMessage: string
}

interface IState {
  isLoading: boolean;
  error: any;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  validationMessage: string;
  diseases: Array<DiseaseForGridModel>
  currentDisease: DiseaseForGridModel | undefined;
  currentFilterSettings: DiseaseFilterSettingsModel
}

const initFrom = 0;
const numberOfRows = 10;

class DiseaseListDialog extends React.Component<IProps, IState> {
  diseaseService = new DiseaseService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      validationMessage: this.props.validationMessage,
      diseases: new Array<DiseaseForGridModel>(),
      currentDisease: new DiseaseForGridModel(),
      currentFilterSettings: new DiseaseFilterSettingsModel()
    }
  }

  componentDidMount() {
    this.getAllFilteredItems(this.state.from, this.state.numberOfRows, this.state.currentFilterSettings);
  }

  getAllFilteredItems(from: number, numberOfRows: number, currentFilterSettings: DiseaseFilterSettingsModel) {
    this.setState({
      isLoading: true
    });

    this.diseaseService.getAllDiseases(from, numberOfRows, currentFilterSettings).then(
      (data: DiseaseGridModel) => {
        this.setState({
          isLoading: false,
          from: from,
          diseases: data.diseases,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  handleOnPageClick = (e) => {
    const startIndex = e.first;
    this.getAllFilteredItems(startIndex, this.state.numberOfRows, this.state.currentFilterSettings);
  }

  handleAddButton = event => {
    event.preventDefault();
    const currentDisease = this.state.currentDisease;
    this.props.addClick(currentDisease);
  }

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  handleFilterChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name;

    const currentFilterSettings: DiseaseFilterSettingsModel = { ...this.state.currentFilterSettings };
    currentFilterSettings[name] = value;
    this.setState({
      currentFilterSettings: { ...currentFilterSettings }
    });
  }

  handleFilterButtonClick = (settings) => {
    this.getAllFilteredItems(this.state.from, this.state.numberOfRows, settings);
  }

  handleClearButtonClick = () => {
    this.setState({
      currentFilterSettings: new DiseaseFilterSettingsModel()
    });

    this.handleFilterButtonClick(new DiseaseFilterSettingsModel());
  }

  displayHeaderSelection(currentDisease: DiseaseForGridModel | undefined) {
    if (!currentDisease || (currentDisease && !currentDisease.diseaseCode)) {
      return <div style={{ textAlign: 'left' }}>No Selection</div>;
    }
    else {
      return <div style={{ textAlign: 'left' }}>Selected disease:&nbsp;
      {[currentDisease.diseaseCode, currentDisease.diseaseNameBG, currentDisease.diseaseNameEN].filter(Boolean).join(' / ')}</div>
    }
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleFilterButtonClick(this.state.currentFilterSettings)
    }
  }

  //TODO: Add const for objects so to not use full this.state....
  render() {
    let { diseases, currentDisease } = this.state;
    let { validationMessage } = this.props;

    return (
      <Dialog header="Diseases" responsive={true} width="60%"
        modal={true}
        visible={this.props.isVisible}
        onHide={this.handleCancelButton}
        footer={
          <div>
            <Button label="Add" icon="pi pi-check" onClick={this.handleAddButton} className="p-button-raised" />
            <Button label="Cancel" icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
          </div>
        }>
        {validationMessage ? <AlertMessage type='danger'>{validationMessage}</AlertMessage> : null}
        <Toolbar style={{ marginBottom: '10px' }}>
          <div>
            <div className="p-grid p-fluid p-md-12">
              <div className="p-col-12 p-md-6">
                <InputText
                  onKeyPress={(e) => this.handleKeyPress(e)}
                  name="diseaseCode"
                  placeholder="Disease code"
                  onChange={this.handleFilterChange}
                  value={this.state.currentFilterSettings && this.state.currentFilterSettings.diseaseCode ? this.state.currentFilterSettings.diseaseCode : ''}
                />
              </div>
              <div className="p-col-12 p-md-6">
                <InputText
                  onKeyPress={(e) => this.handleKeyPress(e)}
                  name="diseaseName"
                  placeholder="Disease name"
                  onChange={this.handleFilterChange}
                  value={this.state.currentFilterSettings && this.state.currentFilterSettings.diseaseName ? this.state.currentFilterSettings.diseaseName : ''}
                />
              </div>
            </div>
            <div style={{ float: "right" }}>
              <div className="p-grid p-fluid p-md-12">
                <div className="p-col-12 p-md-6" >
                  <Button
                    className="p-button-raised"
                    icon="pi pi-filter"
                    label="Filter"
                    onClick={() => this.handleFilterButtonClick(this.state.currentFilterSettings)}
                  />
                </div>
                <div className="p-col-12 p-md-6" style={{ float: "right" }}>
                  <Button
                    className="p-button-secondary p-button-raised"
                    label="Clear"
                    icon="pi pi-times"
                    onClick={() => this.handleClearButtonClick()}
                  />
                </div>
              </div>
            </div>
          </div>
        </Toolbar >
        <div style={{ minHeight: '400px', maxHeight: '550px', overflowY: 'auto' }}>
          <DataTable
            value={diseases}
            paginator={true}
            lazy={true}
            rows={this.state.numberOfRows}
            first={this.state.from}
            selectionMode="single"
            selection={currentDisease}
            header={this.displayHeaderSelection(currentDisease)}
            totalRecords={this.state.totalRecordsCount}
            onPage={(event) => this.handleOnPageClick(event)}
            onSelectionChange={(e) => this.setState({ currentDisease: e.data })}>
            <Column selectionMode="single" style={{ width: '3em' }} />
            <Column field="diseaseCode" header="Disease Code" />
            <Column field="diseaseNameBG" header="Disease Name BG" />
            <Column field="diseaseNameEN" header="Disease Name EN" />
          </DataTable>
        </div>
      </Dialog >
    )
  }

}

export default DiseaseListDialog;